import type { DataOf } from '@elara/firebolt/shared';

import { z } from 'zod';

import { collectionPath, defineModelSpec } from '@elara/firebolt/shared';
import { zFirestampOptional } from '@elara/firebolt/zod-types';

import { ParticipantSchema } from './schemas/ParticipantSchema.js';
import { id } from './schemas/zod-types.js';

/**
 * The canonical `ModelSpec` for the main chats collection.
 * It defines the path (`chats/{id}`) and the data shape for a chat document.
 */
export const ChatModelSpec = defineModelSpec({
  path: collectionPath`chats/${id}`,
  shape: {
    userId: z.string(),
    tripId: z.string().describe('Required reference to parent Trip'),
    title: z.string(),
    description: z.string().optional(),
    participants: z.array(ParticipantSchema),
    status: z.enum(['active', 'archived']).default('active'),
    archivedAt: zFirestampOptional(),
    lastMessageAt: zFirestampOptional(),
    // Counter for message sequencing to ensure deterministic ordering
    messageSequence: z.number().int().nonnegative().optional().describe('Counter for message sequencing'),
    // Legacy session state compatibility fields kept for transition support
    sessionState: z.any().optional().describe('Legacy session state data'),
    sessionThreads: z.record(z.string(), z.string()).optional().describe('Legacy session thread metadata'),
  },
});

export type ChatModelSpec = typeof ChatModelSpec;

export interface ChatData extends DataOf<ChatModelSpec> {}
